<template>
  <div class="let-swap-option">
    <div class="let-swap-wrap" :class="[ mode==='tavnit' ? 'pb-2' : 'pb-3']">     
      <div class="custom-control custom-checkbox mt-1 px-0">
        <b-form-checkbox
          id="allowletswap"
          @change="setSwapClicked"
          v-model="setAllSwap"
          :indeterminate="indeterminate"
          class="d-inline"
        >{{hebrew ? 'כלול מילים בעלות דמיון פונטי' : 'Show only phonetically similar words'}}</b-form-checkbox>
        <span id="let-swap-popover">         
          <i class="fa fa-info-circle mx-1"></i>
        </span>
        <b-popover
          target="let-swap-popover"
          container
          placement="top"
          triggers="hover focus"
        ><p class="mb-1">אם אפשרות זו מופעלת, התוצאות יכללו גם מילים שחורזות בעיצורים שנהגים בצורה זהה לעיצורים של מילת הקלט (ב/ו, ט/ת, כ/ח, כ/ק, ס/ש), וכן מילים שחורזות בתנועות הזהות כמעט בהגייתן (פתח/קמץ, צירה/סגול). למשל, למילה 'תַּכְסִיסֵי' תובא בין התוצאות 'לְהִנָּשֵׂא', וגם 'תִּתְכַּסֶּה'.</p>
        <p class="my-0">לעומת זאת, אם אפשרות זו מכובה, התוצאות יכללו רק מילים שחורזות באותם העיצורים והתנועות של מילת הקלט. כך, למילה 'תַּכְסִיסֵי', יובאו רק מילים כגון 'רְסִיסֵי' או 'מַכְנִיסֵי'.</p>
        </b-popover>        
        <i
          class="fas fa-sort-down mx-1 position-relative d-inline"
          style="top:-3px"
          v-if="!showLetswapOptions && mode!=='tavnit'"
          @click.prevent="showLetswapOptions=true"
        ></i>
        <i
          class="fas fa-sort-up mx-1 position-relative d-inline"
          style="top:4px"
          v-else-if="showLetswapOptions"
          @click.prevent="showLetswapOptions=false"
        ></i><!-- && mode!=='tavnit'-->
      </div>
      <div v-if="showLetswapOptions" class="pt-2 px-4">
        <b-form-checkbox          
          id="vowel-let-swap"
          class="mb-1"
          v-model="vocalSwap"
        >
          {{hebrew ? 'דמיון בתנועות' : 'Vowel similarity'}}
          <span id="vowel-popover" class="d-none">
            <i class="fa fa-info-circle mr-1"></i>
          </span>
        </b-form-checkbox>
        <b-popover target="vowel-popover" container placement="top" triggers="hover focus"></b-popover>
        <b-form-checkbox         
          id="consonant-let-swap"
          v-model="consonentLetSwap"
        >
          {{hebrew ? 'דמיון בעיצורים' : 'Consonant similarity'}}
          <span
            id="consonant-popover"
            class="d-none"
          >
            <i class="fa fa-info-circle mr-1"></i>
          </span>
        </b-form-checkbox>
        <b-popover target="consonant-popover" container placement="top" triggers="hover focus"></b-popover>
      </div>
    </div>
  </div>
</template>
<script>
import { Actions } from "@/store/stateChanges"
export default {
  name: "LetSwapOption",
  data() {
    return {
      showLetswapOptions: false,
      setAllSwap: true,
      indeterminate: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.setAllSwapValues()
    })
  },
  methods: {
    setAllSwapValues () {
      this.setAllSwap = this.consonentLetSwap && this.vocalSwap
      this.indeterminate = (!this.consonentLetSwap && this.vocalSwap) || (this.consonentLetSwap && !this.vocalSwap)
    },
    setSwapClicked () {
      this.$nextTick(() => {
        this.$store.commit("SET_VOC_SWAP", this.setAllSwap)
        this.$store.commit("SET_LET_SWAP", this.setAllSwap)
        this.$store.dispatch(Actions.RUN_CHARUZIT)
      })
    },
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },
    mode () {
      return this.$store.state.searchModel
    },    
    vocalSwap: {
      get () {
        return this.$store.state.preSubmissionOptions.LetSwapSettings.vocalSwap
      },
      set (value) {
        this.$store.commit("SET_VOC_SWAP", value)
        this.$store.dispatch(Actions.RUN_CHARUZIT)
      }
    },
    consonentLetSwap: {
      get () {
        return this.$store.state.preSubmissionOptions.LetSwapSettings.consonentLetSwap
      },
      set (value) {
        this.$store.commit("SET_LET_SWAP", value)
        this.$store.dispatch(Actions.RUN_CHARUZIT)
      }
    },          
  },
  watch: {
    consonentLetSwap () {
      this.setAllSwapValues()
    },
    vocalSwap () {
      this.setAllSwapValues()
    }
  } 
}
</script>